import ElInputNumber from './InputNumber'

/* istanbul ignore next */
ElInputNumber.install = function (app) {
  app.component(ElInputNumber.name, ElInputNumber)
}

export default ElInputNumber
